import script from "./StrategysTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./StrategysTable.vue?vue&type=script&lang=ts&setup=true"

import "./StrategysTable.vue?vue&type=style&index=0&id=1ca6bcc2&lang=scss"

const __exports__ = script;

export default __exports__